import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

const LOGOUT_LANGUAGE_STORAGE_KEY = 'app.logout.language';

@Component({
  selector: 'app-logout',
  template: `
    <section class="logout-page">
      <div class="logout-card">
        <p class="logout-eyebrow">Verisure MySales Backoffice</p>
        <h1>{{ 'LogoutPage.Title' | translate }}</h1>
        <p>
          {{ 'LogoutPage.Description' | translate }}
        </p>
        <a routerLink="/" class="logout-link">{{
          'LogoutPage.Action' | translate
        }}</a>
      </div>
    </section>
  `,
  styles: [
    `
      :host {
        display: block;
        min-height: 100vh;
      }

      .logout-page {
        min-height: 100vh;
        display: grid;
        place-items: center;
        padding: 2rem;
      }

      .logout-card {
        width: min(100%, 32rem);
        padding: 3rem;
        border-radius: 1.5rem;
        background: rgba(255, 255, 255, 0.92);
        box-shadow: 0 1.5rem 3rem rgba(76, 12, 20, 0.12);
        text-align: center;
      }

      .logout-eyebrow {
        margin: 0 0 0.75rem;
        color: #ab192d;
        font-size: 0.875rem;
        font-weight: 700;
        letter-spacing: 0.12em;
        text-transform: uppercase;
      }

      h1 {
        margin: 0 0 1rem;
        color: #32080d;
        font-size: clamp(2rem, 4vw, 2.75rem);
        line-height: 1.1;
      }

      p {
        margin: 0;
        color: #5b4a4d;
        font-size: 1rem;
        line-height: 1.6;
      }

      .logout-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 12rem;
        margin-top: 1.75rem;
        padding: 0.9rem 1.4rem;
        border-radius: 999px;
        background: #ab192d;
        color: #ffffff;
        font-weight: 600;
        text-decoration: none;
      }

      .logout-link:hover,
      .logout-link:focus-visible {
        background: #7f1421;
      }

      @media (max-width: 640px) {
        .logout-card {
          padding: 2rem 1.5rem;
        }
      }
    `
  ],
  imports: [RouterLink, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoutComponent implements OnInit {
  private readonly translateService = inject(TranslateService);

  ngOnInit(): void {
    const storedLanguage = sessionStorage.getItem(LOGOUT_LANGUAGE_STORAGE_KEY);

    if (storedLanguage) {
      this.translateService.use(storedLanguage);
    }
  }
}
